export default __webpack_public_path__ + "static/media/defense.c53db655.png";